import { useAtomValue } from "jotai";
import {
  DefaultNodeData,
  isPublicAtom,
  hasZslAtom,
  ZapNodeData,
  AssetType,
} from "@zapier/canvas-state";

import { ZapLink } from "../ZapLink";
import { InterfaceLink } from "../InterfaceLink";
import { InterfaceFormsStatus } from "../InterfaceFormsStatus";
import { TableLink } from "../TableLink";
import { ZapStatus } from "./ZapStatus";
import styles from "./StepStatusRow.module.css";
import { ChatbotLink } from "../ChatbotLink";

export type StepStatusRowProps = {
  nodeId: string;
  assetType: AssetType;
  zapId: ZapNodeData["zapId"];
  interfaceProjectId?: DefaultNodeData["projectId"];
  interfacePageId?: DefaultNodeData["pageId"];
  tableId?: DefaultNodeData["tableId"];
  chatbotId?: DefaultNodeData["chatbotId"];
};

export function StepStatusRow({
  nodeId,
  assetType,
  zapId,
  interfaceProjectId,
  interfacePageId,
  tableId,
  chatbotId,
}: StepStatusRowProps) {
  const hasZsl = useAtomValue(hasZslAtom);
  const isPublic = useAtomValue(isPublicAtom);

  const shouldShow = !hasZsl && !isPublic;

  if (!assetType || !shouldShow) {
    return null;
  }

  return (
    <div className={styles.stepStatusRow}>
      {interfaceProjectId && interfacePageId && (
        <InterfaceFormsStatus
          nodeId={nodeId}
          interfaceProjectId={interfaceProjectId}
          interfacePageId={interfacePageId}
        />
      )}
      {zapId && <ZapStatus zapId={zapId} />}
      {zapId && (
        <div className={styles.linkWrapper}>
          <ZapLink zapId={zapId} location="node" />
        </div>
      )}
      {interfaceProjectId && (
        <div className={styles.linkWrapper}>
          <InterfaceLink
            nodeId={nodeId}
            interfaceProjectId={interfaceProjectId}
            interfacePageId={interfacePageId}
          />
        </div>
      )}
      {tableId && (
        <div className={styles.linkWrapper}>
          <TableLink tableId={tableId} />
        </div>
      )}
      {chatbotId && (
        <div className={styles.linkWrapper}>
          <ChatbotLink chatbotId={chatbotId} />
        </div>
      )}
    </div>
  );
}
